import React from "react";
import { useState, useEffect, useCallback } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { SuperAdminFeatureGrid, SuperAdminPlanGrid } from "./SuperAdminGrids"
import { logout, capitalizeFirstLetter } from "../../utils";
import { NoAccessPopup } from "../../reusable-components/NoAccessPopupComponent/NoAccessModal";
import './SuperAdmin.css'
import * as Icon from "react-bootstrap-icons";
import Modal from "react-bootstrap/Modal";
import Element from '../../reusable-components/InputFields/input';
import { FormContext } from '../../reusable-components/InputFields/FormContext';
import { ToastContainer, toast } from "react-toastify";
import CheckboxTree from "react-checkbox-tree-enhanced";
import { getFromLS, setToLS } from "../../utils/storage";
import { ThreeCircles } from "react-loader-spinner";
import { groupBy } from "../../utils"
import CryptoJS from "crypto-js";

const SuperAdmin = () => {
  const featureName = "FRMADMN";
  let token = localStorage.getItem("token");
  const accessibleFeatures = getFromLS('active-features')
  const [firmPlanRowData, setFirmPlanRowData] = useState([]);
  const [planFeatureRowData, setPlanFeatureRowData] = useState([]);
  const [allFeatureApiResponse, setAllFeatureApiResponse] = useState();
  const [allFeaturesData, setAllFeaturesData] = useState({})
  const [allPlansData, setAllPlansData] = useState({})
  const [modalState, setModalState] = useState(false)
  const [addUserFormSchema, setAddUserFormSchema] = useState([])
  const [treeNodes, setTreeNodes] = useState([]);

// Setting page url for helper function
  useEffect(() => {
    setToLS("url",  ["superadmin"])
  }, [])

/**
 * Get the form schema for adding firm.
 */
  useEffect(() => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    };
    fetch(
      `${process.env.REACT_APP_BASE_URI}/workflow/add/firm_2/`,
      requestOptions
    ).then((result) => result.json())
      .then((data) => setAddUserFormSchema(data.data))
  }, [])

  /**
   * Get all features available in the platform.
   */
  const getAllFeatures = () => {
    const getRequestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
    };
    fetch(
      `${process.env.REACT_APP_BASE_URI}/workflow/subscriptions/all_features/`,
      getRequestOptions
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((result) => setAllFeatures(result))
  };

  /**
   * Get plans available for firm. This data is used to render active plans.
   */
  const getFirmPlans = () => {
    const getRequestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
    };
    fetch(
      `${process.env.REACT_APP_BASE_URI}/workflow/subscriptions/packages/firms/`,
      getRequestOptions
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        // console.log("SUPERADMIN RESULT: ", response)
        return response.json();
      })
      .then((result) => {
        setFirmPlanData(result)
      })
  }

  /**
   * Get all plans available. This data is used to render select plan options.
   */
  const getAllPlans = () => {
    const getRequestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
    };
    fetch(
      `${process.env.REACT_APP_BASE_URI}/workflow/subscriptions/packages/`,
      getRequestOptions
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((result) => setAllPlans(result))
  };

  // Getting the data by calling necessary APIs
  useEffect(() => {
    getAllFeatures()
    getAllPlans()
  }, [])

  useEffect(() => {
    getFirmPlans()
  }, [allPlansData])

  // Render the tree structure for all the available features.
  useEffect(() => {
    if (allFeatureApiResponse != undefined) {
      const groupedFeatures = groupBy(allFeatureApiResponse, "FeatureGroup");
      console.log("GROUPED FEATURES: ", groupedFeatures);
      let nodes = []
      let child1Option = {}
      child1Option["value"] = "Visual"
      child1Option["label"] = "Visual"
      child1Option["id"] = "VisualId"
      child1Option["children"] = []

      let child2Option = {}
      child2Option["value"] = "Conversational"
      child2Option["label"] = "Conversational"
      child2Option["id"] = "ConversationalId"
      child2Option["children"] = []

      let child3Option = {}
      child3Option["value"] = "My flows"
      child3Option["label"] = "My flows"
      child3Option["id"] = "MyFlowsId"
      child3Option["children"] = []

      for (let category in groupedFeatures) {
        let nodeObject = {}
        nodeObject["value"] = capitalizeFirstLetter(category)
        nodeObject["label"] = capitalizeFirstLetter(category)
        nodeObject["children"] = []

        for (let option in groupedFeatures[category]) {
          if (category === "Insights") {
            console.log("INSIGHTS FEATURES: ", groupedFeatures[category][option])
            if (groupedFeatures[category][option].FeatureSubGroup === "report") {
              let childOption = {}
              childOption["value"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
              childOption["label"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
              childOption["id"] = groupedFeatures[category][option].FeatureId
              child1Option["children"].push(childOption)
            } else if (groupedFeatures[category][option].FeatureSubGroup === "insights") {
              let childOption = {}
              childOption["value"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
              childOption["label"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
              childOption["id"] = groupedFeatures[category][option].FeatureId
              child2Option["children"].push(childOption)
            }
          } else if (category === "flows") {
            console.log("FLOWS FEATURES: ", groupedFeatures[category][option])
            if (groupedFeatures[category][option].FeatureSubGroup === "My Flows") {
              let childOption = {}
              childOption["value"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
              childOption["label"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
              childOption["id"] = groupedFeatures[category][option].FeatureId
              child3Option["children"].push(childOption)
            } else {
              let childOption = {}
              childOption["value"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
              childOption["label"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
              childOption["id"] = groupedFeatures[category][option].FeatureId
              nodeObject["children"].push(childOption)
            }
          }
          else {
            let childOption = {}
            childOption["value"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
            childOption["label"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
            childOption["id"] = groupedFeatures[category][option].FeatureId
            nodeObject["children"].push(childOption)
          }
        }
        if (category === "Insights") {
          nodeObject["children"].push(child1Option)
          nodeObject["children"].push(child2Option)
        } else if (category === "flows") {
          nodeObject["children"].push(child3Option)
        }
        nodes.push(nodeObject)
      }
      setTreeNodes(nodes)
    }
  }, [allFeaturesData]);

  /**
   * Based on all available features, rendering the row data for grid in required format.
   */
  const setPlanFeatureData = (e) => {
    const all_plans = getFromLS("all_plans")
    const admin_grid_row_data = []
    for (const firm in all_plans) {
      const feature_dict = {}
      const featureList = all_plans[firm].FeaturesList
      feature_dict["Plan Id"] = all_plans[firm].PackageId
      feature_dict["Plan"] = all_plans[firm].PackageName
      feature_dict["Features"] = featureList.map(feature => feature.Name)
      admin_grid_row_data.push(feature_dict)
    }
    // console.log("SET ALL PLAN DATA: ", admin_grid_row_data)
    setPlanFeatureRowData(admin_grid_row_data)
  }

  /**
   * Based on firm plan, rendering the row data for grid in required format.
   */
  const setFirmPlanData = (result) => {
    const admin_grid_row_data = []
    const firm_plans = result.data
    // console.log("SET FIRM PLAN DATA: ", firm_plans)
    for (const firm in firm_plans) {
      const feature_dict = {}
      feature_dict["Firm Id"] = firm_plans[firm].FirmId
      feature_dict["Firm Name"] = firm_plans[firm].FIrmName
      feature_dict["Active"] = firm_plans[firm].Active == "Y" ? true : false
      feature_dict["Plans"] = allPlansData[firm_plans[firm].PackageId]
      admin_grid_row_data.push(feature_dict)
    }
    // console.log("SET FIRM PLAN DATA: ", admin_grid_row_data)
    setFirmPlanRowData(admin_grid_row_data)
  }

  /**
   * Setting all features in a ID -> Name map.
   * @param {*} result: All feature API response.
   */
  const setAllFeatures = (result) => {
    setAllFeatureApiResponse(result.data)
    const all_features = result.data
    const features_id_name_mapper = {}
    for (let feature in all_features) {
      features_id_name_mapper[all_features[feature].FeatureId] = all_features[feature].Name
    }
    setAllFeaturesData(features_id_name_mapper)
  }

  /**
   * Setting all plans in a ID -> Name map.
   * @param {*} result: All plans API response.
   */
  const setAllPlans = (result) => {
    const all_plans = result.data
    setToLS("all_plans", all_plans)
    const plans_id_name_mapper = {}
    for (let feature in all_plans) {
      plans_id_name_mapper[all_plans[feature].PackageId] = all_plans[feature].PackageName
    }
    setAllPlansData(plans_id_name_mapper)
  }

  /**
   * Grid loader.
   */
  let gridApi;
  const onGridReady = useCallback((params) => {
    gridApi = params.api
    gridApi.closeToolPanel();
  }, []);


  const AddUserModal = (props) => {
    const formSchema = addUserFormSchema.map(a => Object.assign({}, a))
    const [fullSchema, setFullSchema] = useState(formSchema)
    const [elements, setElements] = useState(fullSchema);
    const [apiInProgress, setApiInProgress] = useState(false)
    const handleChange = (field_id, event) => {
      const newElements = [...elements]
      newElements.forEach(field => {
        // console.log("type: ", type)
        const { type, id } = field;
        if (field_id === id) {
          switch (type) {
            case 'checkbox':
              field['value'] = event.target.checked;
              break;

            case 'select':
              field['value'] = event.value;
              break;

            case 'date':
              field['value'] = event;
              break;

            default:
              field['value'] = event.target.value;
              break;
          }
        }
        const newFullSchema = [...newElements]
        setElements(newFullSchema)
      });
    }
    const handleSubmit = (event) => {
      setApiInProgress(true)
      event.preventDefault();
      // console.log("ELEMENTS ON RUN WORKFLOW: ", elements)
      let label_id_map = {}
      for (let field_index in elements) {
        Object.assign(label_id_map, { [elements[field_index].label]: parseInt(field_index) })
      }
      console.log("label_id_map: ", label_id_map)

      // Hash the password using SHA-256
      const hashedPassword = CryptoJS.SHA256(elements[label_id_map["Firm Admin Password"]].value).toString();

      const payload = {
        "Firm Name": elements[label_id_map["Firm Name"]].value,
        "First Name": elements[label_id_map["First Name"]].value,
        "Last Name": elements[label_id_map["Last Name"]].value,
        "Email": elements[label_id_map["Email"]].value,
        "Firm Admin Username": elements[label_id_map["Firm Admin Username"]].value,
        "Firm Admin Password": hashedPassword
      }
      
      const postOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      };

      fetch(`${process.env.REACT_APP_BASE_URI}/workflow/add/firm/`, postOptions)
        .then((response) => {
          if (!response.ok) {
            if (response.status === 401) {
              // Handle unauthorized error
              logout();
              alert("Session ended , Please login back");
            } else {
              throw new Error("Request failed.");
            }
          }
          return response.json();
        })
        .then((data) => {
          // console.log("data successfully saved", data);
          if (data.success == true) {
            toast.success(
              "Data successfully saved!",
              {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-success",
              }
            );
            showModal()
            setElements(formSchema)
          } else {
            toast.error(
              "Saving failed, " + data.message,
              {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-error",
              }
            );
          }
        })
        .then(() => {
          setApiInProgress(false)
        })
        .catch((err) => console.log("Err: ", err));
    }

    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
        className={"smallmodal"}
      >
        <Modal.Header closeButton className="modal-header-title">
          {
            <h6>{ }</h6>
          }

        </Modal.Header>
        <Modal.Body>
          <FormContext.Provider value={{ handleChange }}>
            <Form>
              <Row className="no-gutter">
                {
                  elements &&
                  elements.map((field, i) =>
                    <Element
                      key={i}
                      field={field}
                      md={6}
                    />)
                }
              </Row>
            </Form>
          </FormContext.Provider>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit" onClick={(e) => handleSubmit(e)} className={!apiInProgress ? "superadmin-button" : "apiInProgress"}>{!apiInProgress ? "Add" :
            <>Add &nbsp;
              <ThreeCircles
                height="20"
                width="20"
                color="#4fa94d"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="three-circles-rotating"
                outerCircleColor="var(--theme1_primary)"
                innerCircleColor="var(--theme1_secondary)"
                middleCircleColor="var(--theme1_tertiary)"
              />
            </>}</Button>
        </Modal.Footer>
      </Modal>
    )
  }

  const showModal = () => { setModalState(!modalState) }
  const handleSelect = (e) => { setPlanFeatureData() }

  // Refresh grid function calls.
  const refreshGrid = () => {
    getAllFeatures()
    getAllPlans()
  }

  // Check for access else return no access modal
  // if (!accessibleFeatures.includes(featureName)) {
  //   return (
  //     <NoAccessPopup
  //       featurename={featureName}
  //     />
  //   )
  // }


  return (
    <>
      <AddUserModal
        show={modalState}
        onHide={() => setModalState(false)}
      />
      <div className="row-wrapper">
        <div className="row-container">
          <p className="display-6" style={{ margin: "20px 0px 10px 0px" }}>Super Admin</p>
          <Button
            className="custom-button"
            style={{ margin: "10px 0px 10px 0px" }}
            onClick={() => showModal()}
          >
            <Icon.Plus /> Add
          </Button>
          <Tabs
            defaultActiveKey="manage_plans"
            id="uncontrolled-tab-example"
            className="mb-3"
            onSelect={(e) => handleSelect(e)}
          >
            <Tab eventKey="manage_plans" title="Firm plan management" className="tabs">
              <Icon.ArrowClockwise onClick={() => refreshGrid()} fill="black" className="reset-button download-excel refresh-button" />
              <Row>
                <Col md="12" className="grid-row super-admin super-admin-grid">
                  <SuperAdminPlanGrid
                    rowData={firmPlanRowData}
                    rowSelection={'multiple'}
                    rowMultiSelectWithClick={true}
                    sortable={true}
                    filter={true}
                    resizable={true}
                    onGridReady={onGridReady}
                    allPlansData={allPlansData}
                  />
                </Col>
              </Row>
            </Tab>

            <Tab eventKey="manage_users" title="Firm feature access management" className="tabs">
              <Icon.ArrowClockwise onClick={() => refreshGrid()} fill="black" className="reset-button download-excel refresh-button" />
              <Row>
                <Col md="12" className="grid-row super-admin super-admin-grid">
                  <SuperAdminFeatureGrid
                    rowData={planFeatureRowData}
                    rowSelection={'multiple'}
                    rowMultiSelectWithClick={true}
                    sortable={true}
                    filter={true}
                    resizable={true}
                    onGridReady={onGridReady}
                    allFeaturesData={allFeatureApiResponse}
                    checkTreeNodes={treeNodes}
                  />
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
}

export default SuperAdmin;
